import Signal from "badmfck-signal";
import { IStatBarChart, IStatBarChartSectional } from "./types";
import type { SectionalBarListProps } from "./SectionalBarList";

export const S_BAR_CHART_DETAILS = new Signal<{ title: string; data: IStatBarChart[]; colors?: string[]; icon?: "country" } | null>("S_BAR_CHART_DETAILS");
export const S_BAR_CHART_SECTIONAL_DETAILS = new Signal<{ title: string; data: IStatBarChartSectional[]; legend?: { colors: string[]; labels: string[] }; icon?: "country"; getRowAction?: SectionalBarListProps["getRowAction"] } | null>(
	"S_BAR_CHART_SECTIONAL_DETAILS",
);
